import { NuvemEnvioCreateDispatchesResponseDto } from '@tiendanube/common';

export const hasOnlyErrorsOnPrintLabel = (
  response: NuvemEnvioCreateDispatchesResponseDto,
): boolean =>
  !!response.errors.length &&
  !response.labelUrls.length &&
  !response.contentDeclarationUrls.length;
